import { render, staticRenderFns } from "./CheckboxSwitcher.vue?vue&type=template&id=e6d765e8&scoped=true"
import script from "./CheckboxSwitcher.vue?vue&type=script&lang=js"
export * from "./CheckboxSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CheckboxSwitcher.vue?vue&type=style&index=0&id=e6d765e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d765e8",
  null
  
)

export default component.exports